export default {
	termsAndConditions: {
		lastUpdate: 'Poslední aktualizace: 10. června 2024',
		content: `
		<p>Podmínky, které najdete níže, jsou důležité, protože:</p>
		<ul>
			<li>Zakládají svá zákonná práva na webu {siteName}.</li>
			<li>Vysvětlete nám práva, která nám udělujete, když používáte {siteName}.</li>
			<li>
				Popisují pravidla, která musí každý respektovat při používání {siteName}.
			</li>
		</ul>
		<p>
			Přečtěte si prosím pozorně tyto podmínky, stejně jako naše {privacyPolicyLink} a další
			dokumenty uvedené v těchto podmínkách.
		</p>
		<p>Začněme...</p>
		<h3>1. ÚVOD A ÚDAJE O {siteNameUpper}.</h3>
		<p>
			Webová stránka {websiteLink} (dále jen „webová stránka“) je ve vlastnictví společnosti
			{siteName} S.L (dále jen „{siteName}“), společnost
			zapsána v souladu se španělskými právními předpisy s adresou na Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), držitel čísla CIF
			B-56.768.260 a registrovaná v obchodním rejstříku v Barceloně ve svazku
			49065, Folio 0033, List B-606324, 1. registrace.
		</p>
		<p>
			{siteName} vám dává web k dispozici, abyste se na něj mohli dostat
			poznejte nás lépe, poznejte služby, které poskytujeme, a pokud si přejete, můžete nás kontaktovat
			a případně s námi uzavřít smlouvu.
		</p>
		<h3>2. ÚČEL A ROZSAH POUŽITÍ PODMÍNEK POUŽITÍ</h3>
		<p>
			Tyto podmínky použití tvoří spolu s {privacyPolicyLink} a
			{cookiesPolicyLink}, právní rámec, který reguluje používání webové stránky
			{odkaz na webovou stránku}. Tyto podmínky použití vám budou k dispozici na webových stránkách
			v angličtině, takže si je můžete kdykoli prohlédnout, archivovat nebo vytisknout
			kdykoli budete chtít.
		</p>
		<p>
			Chcete-li znát jakékoli dotazy týkající se léčby prováděné {siteName}.
			vašich osobních údajů, navštivte naše {privacyPolicyLink} a {cookiesPolicyLink}.
			Obě zásady vám budou k dispozici také v angličtině, abyste mohli
			si je kdykoli můžete prohlédnout, archivovat nebo vytisknout.<br />
			{siteName} používá na webu soubory cookie třetích stran. Zjistit více
			o typu souborů cookie používaných na webu {websiteLink}, jejich účelu a způsobu
			ke konfiguraci vašeho prohlížeče v případě, že si nepřejete, abychom tyto soubory cookie používali,
			navštivte naše {cookiesPolicyLink}.
		</p>
		<p>
			Obě tyto podmínky použití, stejně jako {privacyPolicyLink} a 
			{cookiesPolicyLink} byly připraveny v souladu s aktuálními ustanoveními
			platné předpisy, mimo jiné zákon č. 34/2002 Sb., o službách hl
			Informační společnost a elektronický obchod a nařízení (EU) 2016/679 ze dne
			Evropského parlamentu a Rady ze dne 27. dubna 2016 o
			ochrany fyzických osob v souvislosti se zpracováním osobních
			údajů a volného oběhu těchto údajů a podle které směrnice 95/46 / CE
			se zrušuje.
		</p>
		<h3>3. PŘÍSTUP NA STRÁNKY A PŘIJETÍ</h3>
		<p>
			Přístup na webové stránky je bezplatný, s výjimkou části související s náklady na web
			připojení přes telekomunikační síť poskytovanou internetem
			poskytovatele přístupu, se kterým jste uzavřeli smlouvu. Webové stránky můžete volně procházet
			a přistupovat k němu tolikrát, kolikrát chcete. Chcete-li získat přístup a procházet webovou stránku,
			nemusíte se registrovat, kromě případů, kdy si chcete najmout službu.
		</p>
		<p>
			Používání webu vám dává stav uživatele webu
			(dále jen „Uživatel“) a znamená váš úplný a bezvýhradný souhlas
			tyto podmínky použití a také {privacyPolicyLink} a {cookiesPolicyLink}
			webové stránky. Dále souhlasíte s tím, že nebudete používat Službu k nezákonným účelům
			účely.
		</p>
		<p>
			Vstupem na webovou stránku a jejím procházením prohlašujete pod svým
			odpovědnost za to, že jste plnoletí a že máte potřebnou zákonnost
			kapacitu pro přístup k Webovým stránkám a jejich používání, a zároveň prohlašujeme, že plně
			rozumíte a přijímáte tyto podmínky použití bez výhrad.
		</p>
		<p>
			Na druhou stranu vás informujeme, že z právních důvodů archivujeme
			elektronické dokumenty, ve kterých jsou nákupy formalizovány. Můžete přistupovat
			tyto dokumenty můžete kdykoli vyžádat na adrese: {supportLink}.
		</p>
		<h3>4. PODMÍNKY POUŽÍVÁNÍ WEBOVÝCH STRÁNEK</h3>
		<p>
			Uživatel souhlasí s používáním Webu v souladu s těmito podmínkami používání,
			aktuální legislativa a dobrá víra. Uživatel tedy odpoví na {siteName}.
			 a před jakoukoli třetí stranou za způsobené škody a ztráty
			použití v rozporu s těmito podmínkami, právními předpisy a v dobré víře
			ze strany Uživatele Webu.
		</p>
		<h3>5. POPIS SLUŽBY</h3>
		<p>
			Prostřednictvím služby {siteName} umožňuje předplatné služby
			provádět úpravy obrázků.
		</p>
		<p>
			Jazyk, ve kterém je uzavřena smlouva mezi {siteName} a kupujícím
			bude uzavřena země původu.<br />
			Proces nákupu v online službě bude následující:
		</p>
		<ol>
			<li>Musíte se zaregistrovat na webu pomocí uživatelského jména a hesla.</li>
			<li>
				Při registraci si uživatel musí vybrat jeden z platebních plánů
				naleznete v sekci Ceny a budou vám poskytnuty kredity v závislosti na
				vybraný plán. Každý kredit vám umožní upravit jeden obrázek.
			</li>
			<li>
				Po zakoupení služby bude uživateli k dispozici administrace
				panel, kde najdou:
				<ul>
					<li>
						Sekce se seznamem všech obrázků, které byly zpracovány
						můžete jej upravovat tolikrát, kolikrát chcete, a stahovat do svého
						přístroj.
					</li>
					<li>
						Sekce Plány a platby pro nahlédnutí do faktur a zrušení
						předplatné.
					</li>
					<li>Sekce Můj účet, kde lze změnit předvolby účtu.</li>
				</ul>
			</li>
		</ol>
		<p>
			Jakmile bude nákup služby proveden, bude potvrzen
			odeslání e-mailu, maximálně do 24 hodin, na adresu, kterou máte
			uvedeno. Uvede službu, jak zrušit předplatné, jeho
			částku, příslušné daně, způsob platby a příslušné podmínky a
			podmínky.
		</p>
		<h4>5.1 Předplatné</h4>
		<p>
			Předplatné služby se liší v závislosti na vybraném plánu a bude
			automaticky obnovována na stejnou dobu až do jejího ukončení.
			Pokud nezrušíte své předplatné, opravňujete nás k načtení
			odpovídající roční poplatek za předplatné ve vaší platební metodě.
		</p>
		<p>
			Předplatné služby můžete kdykoli zrušit a také to uděláte
			mít k němu přístup až do konce ročního zúčtovacího období. Na
			v rozsahu povoleném zákonem jsou platby nevratné a neposkytujeme
			refundace nebo kredity za částečná roční předplatitelská období.
		</p>
		<h3>6. CENA A DANĚ</h3>
		<p>
			Ceny produktů nabízených na {siteName} jsou uvedeny v eurech
			(€) nebo měna země, ze které je nákup uskutečněn, Hodnota
			Z ceny zboží se vybírá daň z přidané hodnoty (DPH) platná v době nákupu
			produkty.
		</p>
		<p>
			V každém případě by operace mohla být osvobozena nebo nepodléhat DPH v závislosti na
			zemi vašeho bydliště nebo podmínky, ve kterých jednáte. Z tohoto důvodu,
			v některých případech může být konečná cena objednávky změněna s ohledem na
			jeden zobrazen.<br />
			Nákupy uskutečněné subjekty osvobozenými od DPH to označí
			zaslání svého DIČ/NIF čísla e-mailem na {supportLink}, bez záznamu
			nákupy s uvedenou daní.
		</p>
		<h3>7. ZPŮSOB PLATBY</h3>
		<p>
			Online platbu za zakoupenou službu lze provést kreditní nebo debetní kartou.
			V tomto smyslu {siteName} informuje držitele kreditních a debetních karet
			transakce v internetovém obchodě jsou prováděny prostřednictvím zabezpečené platby
			brána, využívající technologii SSL k zajištění bezpečnosti přenosu dat.
		</p>
		<h3>8. PRÁVO NA ODSTOUPENÍ A VRÁCENÍ PENĚZ</h3>
		<h4>8.1. Právo na odstoupení</h4>
		<p>
			Vzhledem k typu produktu nabízeného v naší online službě je software v digitální podobě
			formátu QR, právo na odstoupení od smlouvy se neuplatní dle
			článek 103, písmeno m) královského legislativního dekretu 1/2007, ze dne 16. listopadu, od
			že revidovaný text obecného zákona na obranu spotřebitele a
			Uživatelé a další doplňkové zákony jsou schváleny.
		</p>
		<h4>8.2. Vrácení peněz</h4>
		<p>
			Bez ohledu na plán zvolený uživatelem, částky zaplacené uživatelem a do
			zákonem povolený rozsah nebude vratný.
		</p>
		<p>
			Smluvenou službu nelze postoupit ani převést na jiné uživatele
			služba.
		</p>
		<p>
			V každém případě může uživatel využívat sjednanou službu až do konce
			smluvní období.
		</p>
		<h3>9. PLATNOST NABÍDEK</h3>
		<p>
			Služby nabízené ve Službě a jejich ceny budou dostupné za
			nákup, když jsou v katalogu služeb zobrazených prostřednictvím tohoto
			webová stránka.
		</p>
		<p>
			V každém případě si {siteName} vyhrazuje právo provést jeho úpravy
			považuje za vhodné ve Službě, mít možnost aktualizovat produkty a služby
			v závislosti na trhu.
		</p>
		<p>
			{siteName} si vyhrazuje právo změnit ceny bez předchozího upozornění. My
			vás informujeme, že navzdory aktualizacím cen
			Servis, mohou obsahovat chyby. Případné chyby neprodleně opravíme
			se objeví, ale nebudou pro Službu závazné.
		</p>
		<h3>10. BEZPEČNOST</h3>
		<p>
			Jak je uvedeno výše, celý proces nákupu, stejně jako přenos
			vašich osobních údajů a platebních systémů, se provádí na zabezpečené stránce a
			šifrovaným způsobem prostřednictvím protokolu SSL.
		</p>
		<p>
			Garantujeme bezpečnost Služby v souladu s aktuálními
			technologické znalosti. {siteName} však nemůže zaručit úplné znění
			budoucí zabezpečení služby. V každém případě slibujeme nápravu a
			provést příslušná nápravná opatření k nápravě případného zabezpečení
			porušení co nejdříve.
		</p>
		<p>
			Souhlasíte s tím, že budete neprodleně informovat {siteName} prostřednictvím e-mailu {supportLink}
			jakékoli situace, která by mohla vést k předstírání identity uživatele.
		</p>
		<h3>11. ÚPRAVY A NEPLATNOST</h3>
		<p>
			V budoucnu můžeme také aktualizovat podmínky služby
			jako vlastnosti a funkce samotné Služby.
		</p>
		<p>
			O změnách podmínek vás budeme informovat prostřednictvím oznámení
			na nápadném místě na našich webových stránkách a/nebo e-mailem.
		</p>
		<p>
			Pokud je deklarována jakákoli klauzule obsažená v těchto podmínkách, zcela nebo
			částečně, neplatná nebo neúčinná, ovlivní pouze uvedené ustanovení nebo jeho část
			z toho, že je nulový nebo neúčinný. Podmínky budou platit v
			všechno ostatní, které má takové ustanovení, nebo jeho část, která je dotčena
			není umístěn.
		</p>
		<h3>12. NÁROKY A ČINNOSTI ODVEZENÉ ZE SMLOUVY</h3>
		<p>
			Pokud je to možné, tato služba se řídí španělským právem.<br />
			Za účelem zjednodušení řešení nároků prostřednictvím občanskoprávního řízení a
			snížit náklady, nevylučujeme možnost podrobit se
			Spravedlnost rozhodčího soudu Rozhodčího soudu obchodních komor a
			Průmysl. V tomto smyslu a podle platných předpisů
			 {siteName} informuje o existenci evropského online řešení sporů
			platforma, která usnadňuje mimosoudní řešení takových sporů
			smlouvy uzavírané také online mezi spotřebiteli a internetovou službou
			poskytovatelé. Tato platforma je přístupná prostřednictvím následující webové stránky:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. PRÁVA DUŠEVNÍHO A PRŮMYSLOVÉHO VLASTNICTVÍ</h3>
		<p>
			Webové stránky a jejich obsah podléhají ochraně při aplikaci
			aktuální národní předpisy o duševním a/nebo průmyslovém vlastnictví, as
			jakož i při aplikaci mezinárodních úmluv v nich platných
			záležitosti. {siteName} je vlastníkem nebo má řádnou licenci ke všem
			Práva duševního a průmyslového vlastnictví na webových stránkách a jejich obsahu.
		</p>
		<p>
			Jakákoli forma reprodukce, distribuce, veřejné komunikace, transformace,
			zpřístupnění a obecně jakýkoli jiný akt využívání, ať už či nikoli
			pro komerční účely Webu nebo jeho obsahu, bez předchozího
			výslovný souhlas {siteName}. Je výslovně zakázáno mazat
			identifikující údaje {siteName} jako vlastníka duševního a
			Práva průmyslového vlastnictví webových stránek nebo jejich obsahu.
		</p>
		<p>
			{siteName} si vyhrazuje veškerá práva duševního a průmyslového vlastnictví
			nad webovou stránkou a jejím obsahem, přičemž si také vyhrazujeme výkon jakýchkoli právních předpisů
			jednání, která tomu odpovídají, za účelem zastavení, zamezení nebo stíhání jakýchkoli
			nedovolené používání webových stránek nebo jejich obsahu. V žádném případě a pod č
			okolnostech přistupuje k Webové stránce nebo její používání Uživatelem nebo třetí osobou
			strany představují nebo naznačují postoupení jakéhokoli druhu ze strany {siteName}
			práva duševního nebo průmyslového vlastnictví webových stránek nebo jejich obsahu.
			V žádném případě nedostatek požadavku ze strany {siteName} přestat používat
			Webové stránky nebo jejich nezákonné nebo obsah v rozporu s těmito podmínkami může být
			chápáno jako tichý souhlas {siteName} s takovým použitím nebo jako zřeknutí se práv
			o výkonu jakéhokoli právního jednání, které mu může odpovídat.
		</p>
		<h3>14. ODPOVĚDNOSTI A ZÁRUKY</h3>
		<p>
			Uživatel musí používat Webové stránky a jejich obsah v souladu s
			ustanovení těchto podmínek použití, platné právní úpravy a dobré víry. Žádný
			používání webových stránek nebo jejich obsahu v rozporu s těmito všeobecnými podmínkami,
			zákonem nebo v dobré víře je výslovně zakázáno, bez ohledu na to, zda takové použití bylo
			ekonomický účel nebo ne.<br />
			Uživatel bude odpovědný za jakoukoli škodu nebo újmu způsobenou webu {siteName}
			 nebo třetím stranám odvozeným přímo nebo nepřímo z jakéhokoli použití
			že Uživatel činí Webové stránky nebo jejich obsah v rozporu s těmito
			podmínek, zákona, morálky, veřejného pořádku nebo dobré víry.
		</p>
		<p>
			Aby byly webové stránky a jejich obsah přístupné uživateli, {siteName}
			 vyžaduje služby poskytované třetími stranami. Je to možné
			navzdory úsilí, které {siteName} vynaložilo, aby byl web dostupný
			a přístupný uživatelům, jeho dostupnost může být pozastavena, přerušena popř
			zrušeno z důvodů mimo {siteName}. Proto {siteName}
			nezaručuje absenci přerušení nebo chyb v přístupu k
			Webové stránky nebo jejich obsah, ani to, že jsou aktualizovány nebo vždy zobrazeny
			jejich nejnovější verzi. V důsledku toho {siteName} jakékoli odmítá
			odpovědnost za škody, které mohou vzniknout Uživateli nebo třetím osobám, jako je
			výsledek pozastavení, přerušení, nedostatek kontinuity, výpadek sítě
			nebo odpojením webu.
		</p>
		<p>
			V žádném případě a za žádných okolností nenese {siteName} odpovědnost
			škody nebo ztráty způsobené uživateli z příčin, které nelze připsat {siteName}
			 jako příklad a v žádném případě neomezující přírodní
			katastrofy, situace vyšší moci nebo krajní nouze, viry, škodlivé
			komponenty, poruchy prohlížeče, výpadky sítě, narušení počítače popř
			útoky třetích stran.
		</p>
		<h3>15. ODKAZY</h3>
		<p>
			Webové stránky, platformy, fóra, chaty, blogy nebo externí sociální sítě, které
			odkaz nebo odkaz na webové stránky musí jasně informovat, že nemají
			autorizace nebo dohled nad {siteName} a to znamená propojení nebo
			odkaz neznamená, nepředpokládá ani nenaznačuje spojení jakéhokoli druhu mezi {siteName}
			 a webové stránky, platformy, fóra, chaty, blogy nebo externí
			sociální sítě, které odkazují nebo odkazují na webové stránky.
		</p>
		<p>
			V každém případě musí být jakýkoli odkaz, který je určen pro webovou stránku, směřován
			přímo na domovskou stránku nebo domovskou stránku Webu kliknutím na URL
			webové stránky pokrývající celou obrazovku domovské stránky nebo úvodní stránky
			webové stránky, takže odkaz je absolutní a úplný bez použití
			rámce, rámečky nebo hypertextové odkazy. {siteName} v žádném případě nereaguje
			a za žádných okolností na obsah, informace nebo data související s
			webové stránky, jejich obsah nebo jakákoli jiná záležitost obsažená na webových stránkách, platformách,
			fóra, chaty, blogy nebo sociální sítě třetích stran, které odkazují nebo odkazují na
			Webová stránka.
		</p>
		<p>
			Je výslovně zakázáno odkazovat nebo odkazovat na webové stránky z webových stránek,
			platformy, fóra, chaty, blogy nebo sociální sítě v rozporu se zákonem, morálkou
			a dobré zvyky, zejména ty s pornografickými, nezákonnými, nezákonnými popř
			obsah porušující lidská práva.
		</p>
		<p>
			Na druhou stranu Webové stránky mohou obsahovat odkazy na webové stránky třetích stran,
			platformy, fóra, chaty, blogy nebo sociální sítě. {siteName} ne
			mít lidské a/nebo technické prostředky k tomu, aby informace znaly nebo je ovládaly, a
			obsah, který se objevuje na webových stránkách třetích stran. Proto v žádném případě {siteName}
			 odpovídá za obsah odkazovaných stránek a pod č
			okolnosti mohou být uvedené odkazy považovány za efektivní znalost obsahu
			webů, na které odkazují.
		</p>
		<h3>16. OCHRANA DAT</h3>
		<p>
			Jak je uvedeno ve svém {privacyPolicyLink}, {siteName} se zavazuje používat uživatele
			údajů, respektovat jejich důvěrnost a používat je v souladu s
			účel léčby, jakož i dodržet svou povinnost ji zachránit.
			a přizpůsobit všechna opatření tak, aby nedošlo k jejich změně, ztrátě, ošetření nebo neoprávněnému použití
			přístup v souladu s ustanoveními současné legislativy týkající se
			ochranu osobních údajů.
		</p>
		<p>
			Webová stránka zahrnuje vhodná ochranná opatření a používá průmyslový standard
			technologie ke zlepšení bezpečnosti, integrity, úplnosti, přesnosti a
			ochranu osobních údajů, které shromáždila a zřídila
			přiměřená opatření k ochraně těchto informací před možnou ztrátou nebo
			zneužít. Její pravidla pro ochranu a bezpečnost dat jsou pravidelně revidována
			a v případě potřeby vylepšovat a snaží se zajistit, aby pouze autorizoval
			osoby mají přístup k informacím poskytnutým Uživatelem.
		</p>
		<p>
			Chcete-li se dozvědět více o správě a léčbě prováděné webem {siteName}
			 vašich údajů si prosím přečtěte naše {privacyPolicyLink} a {cookiesPolicyLink}.
		</p>
		<h3>17. TRVÁNÍ A MODIFIKACE</h3>
		<p>
			Tyto podmínky použití budou v platnosti tak dlouho, dokud jim budou vystaveny
			uživatelů, takže jakmile budou zcela nebo částečně upraveny nebo aktualizovány,
			tyto podmínky přestanou být v platnosti jako nové podmínky používání
			ty, které dále upravují používání webových stránek.
		</p>
		<p>
			{siteName} si vyhrazuje právo je zkontrolovat, upravit nebo aktualizovat
			podmínky použití kdykoli. V případě jakékoli změny těchto podmínek
			použití z jakéhokoli důvodu, {siteName} upozorní uživatele na domovské stránce
			web o uvedené okolnosti, aby byli řádně informováni a mohli konzultovat
			revize, úpravy nebo aktualizace současných podmínek použití
			vaši spokojenost.
		</p>
		<h3>18. OBECNĚ</h3>
		<p>
			V žádném případě a za žádných okolností nemůže nedostatečný výkon vašich práv
			by {siteName} být chápáno jako jejich zřeknutí se.
		</p>
		<p>
			Nadpisy obsažené v těchto podmínkách jsou pouze orientační resp
			informativní, aby neovlivňovaly, nekvalifikovaly nebo nerozšiřovaly výklad
			z toho.
		</p>
		<p>
			V případě, že některá z doložek obsažených v těchto podmínkách byla
			prohlášena za neplatné, zneužívající nebo nevymahatelné, zcela nebo částečně, soudem
			nebo správního orgánu, uvedené prohlášení ovlivní jednotlivě doložku
			předmětné, brát ji jako ne a bez prohlášení neplatnosti, zneužití popř
			nepoužitelnost se za jakýchkoli okolností rozšíří na zbytek
			podmínky, které budou přetrvávat.
		</p>
		<p>
			Tyto podmínky použití a také {privacyPolicyLink} a {cookiesPolicyLink}
			se vždy řídí aktuálními španělskými předpisy.
		</p>
		<h3>19. ZÁKAZNICKÁ SLUŽBA</h3>
		<p>
			Pro jakékoli vysvětlení, incident nebo nárok nás můžete kontaktovat prostřednictvím:<br />
			E-mail: {supportLink}<br />
			Poštovní adresa: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španělsko.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Poslední aktualizace: 10. června 2024',
		content: `
			<h3>1. Odpovědná strana a popis</h3>
			<h5>1.1. Odpovědný</h5>
			<p>Osobou odpovědnou za zacházení s tímto webem je Remove Background S.L (dále jen Remove Background 
			nebo Služba), s adresou Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španělsko.</p>
			<p>NIF: B56768260<br> E-mail: {supportLink}</p>

			<h5>1.2. Popis</h5>
			<p>Přijetí zásad ochrany osobních údajů Odebrat pozadí (dále jen „Zásady ochrany osobních údajů“) je nezbytnou podmínkou 
				pro používání našich webových stránek a poskytování služby (dále jen „Služba“).<br>
				Tyto zásady ochrany osobních údajů upravují shromažďování, zpracování a používání vašich osobních a neosobních údajů 
				jako uživatel Odebrat pozadí k datu účinnosti, které se zobrazí v záhlaví.<br>
				Aby bylo možné zpracovávat vaše osobní údaje, je Remove Background v souladu s aktuální místní a evropskou legislativou, 
				stejně jako jeho prováděcí předpisy.</p>


			<h3>2. Shromážděné informace</h3>
			<p>Přístup na naše webové stránky je možný bez nutnosti poskytovat jakékoli informace, i když se registrujete a / 
				nebo smluvte naše plány, budete nám muset poskytnout nějaké osobní údaje. Informace (osobní 
				nebo neosobní) shromážděné službou se mohou v závislosti na tom lišit.<br>
				Osobní a neosobní údaje shromážděné Službou se k nám dostanou třemi způsoby: 1) tím, který 
				se shromažďuje automaticky 2) to, co nám poskytnete dobrovolně, a 3) to, co poskytnou třetí strany.</p>

			<h5>2.1. Ten shromážděný automaticky</h5>
			<p>Tyto informace se budou skládat z:</p>
			<ul>
				<li>Ten shromážděný prostřednictvím souborů cookie nebo podobných mechanismů uložených ve vašem zařízení, vždy s vaším souhlasem nebo v 
					v souladu s jinými právními základy. Další informace naleznete v našich Zásadách používání souborů cookie.</li>
				<li>IP adresa, ze které je připojení vytvořeno, typ použitého zařízení a jeho vlastnosti, verze 
					operační systém, typ prohlížeče, jazyk, datum, země, čas požadavku, 
					mimo jiné adresu URL z adresy, ze které pocházíte, adresu URL, na kterou přejdete, nebo použitou mobilní síť.</li>
				<li>Údaje o používání služby a možné chyby zjištěné během jejího používání.</li>
				<li>Odstranit pozadí navíc využívá Google Analytics, analytickou službu poskytovanou společností Google, LLC. 
					se sídlem ve Spojených státech amerických se sídlem na adrese 1600 Amphitheatre Parkway, Mountain View, Kalifornie 94043. 
					Pro poskytování těchto služeb využívají cookies, které shromažďují informace, včetně IP adresy uživatele, 
					které budou přenášeny, zpracovávány a ukládány společností Google za podmínek stanovených na webu www.google.com. 
					Včetně případného předání uvedených informací třetím stranám z důvodů zákonného požadavku resp 
					když uvedené třetí strany zpracovávají informace jménem společnosti Google.</li>
			</ul>
			<p>V každém případě můžete soubory cookie Google Analytics zakázat <a href="{externalLink: disableGoogleAnalyticsLink}">zde</a>.</p>

			<h5>2.2. Ten, který dobrovolně poskytnete</h5>
			<p>Tyto informace budou obsahovat:</p>
			<ul>
				<li>Všechny údaje jsou povinné.</li>
				<li>Ten, který vyžaduje Odebrat pozadí k dokončení vaší registrace na webu: mimo jiné jméno a příjmení, adresa a e-mail.</li>
				<li>Všechny údaje jsou povinné.</li>
				<li>Údaje, osobní nebo ne, k dokončení smlouvy o poskytování služby, jako je vaše e-mailová adresa a číslo vaší kreditní nebo debetní karty.</li>
				<li>Informace, osobní či nikoli, které mohou obsahovat zprávy zaslané prostřednictvím kontaktních nebo názorových kanálů zřízených ve službě, 
					například vaše jméno a e-mail.</li>
			</ul>

			<h5>2.3. Ten, který poskytují třetí strany</h5>
			<p>Tyto informace budou obsahovat:</p>
			<ul>
				<li>Tu, kterou poskytují platební systémy nebo zpracovatelé kreditních karet, jako je čas nákupu nebo jeho částka.</li>
			</ul>


			<h3>3. Práva a účely</h3>
			<p>Informujeme vás, že vyplňování formulářů je dobrovolné. Pokud však nevyplníte povinná pole 
				(obvykle označeno hvězdičkou), používání některých funkcí Služby nebude možné nebo bude omezeno.<br>
				Osobní údaje, které nám poskytnete, budou začleněny a zpracovány v Registru léčebných činností odstranění pozadí 
				abychom mohli vyřídit vaše požadavky, poskytnout požadovanou službu a informovat vás o záležitostech souvisejících s činností 
				společnosti a jejích služeb.<br>
				Kdykoli můžete uplatnit práva na přístup, opravu, vymazání, omezení vaší léčby, 
				námitku a přenositelnost vašich osobních údajů e-mailem na adresu: {supportLink} nebo poštovní adresu: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španělsko.<br>
				V obou případech se musíte identifikovat svým jménem a příjmením a v případě potřeby také kopií svého DNI nebo občanského průkazu.<br>
				V případě, že jste souhlas udělili pro konkrétní účel, máte právo souhlas kdykoli odvolat, 
				aniž by byla dotčena zákonnost zacházení založeného na souhlasu před jeho odvoláním.<br>
				Pokud se navíc domníváte, že existuje problém se způsobem, jakým funkce Remove Background nakládá s vašimi daty, 
				můžete své stížnosti směřovat na <a href="{knowYourRightsLink}">úřad pro ochranu údajů</a>, kterému odpovídá, kterým je <a href="{aepdLink}">španělská agentura pro ochranu údajů</a> 
				ten, který je uveden v případě Španělska.</p>


			<h3>4. Věk</h3>
			<p>Pokud jde o používání služby online, prohlašujete, že jste plnoletí a že máte potřebné zákonné 
				schopnost být vázán touto smlouvou a používat stránky v souladu s jejími podmínkami, které v plném rozsahu 
				pochopit a uznat.<br>
				Prohlašujete, že všechny informace, které poskytujete pro přístup ke Službě, před a během jejího používání, jsou pravdivé a úplné 
				a přesné.</p>


			<h3>5. Použití dat</h3>
			<p>Odstranit pozadí použije shromážděná data k:</p>
			<ul>
				<li>Spravujte a aktualizujte Službu (právním základem je náš oprávněný zájem na udržování a udržování Služby 
					aktuální a v dobrém stavu).</li>
				<li>Odpovězte na otázky, které vznesete (právním základem je náš oprávněný zájem na vyřizování žádostí a 
					pochybnosti našich uživatelů).</li>
				<li>Zpracovat platby, které provedete (smlouva je právním základem).</li>
				<li>Poskytovat smluvní službu (právním základem je smlouva).</li>
				<li>Udržovat bezpečnost služby, vyšetřovat nezákonné aktivity, prosazovat naše smluvní podmínky a
					pomoci bezpečnostním složkám státu v rámci jejich případného vyšetřování (právním základem je náš 
					oprávněný zájem na zaručení a udržení bezpečnosti Služby a jejích uživatelů).</li>
			</ul>
			<p>Odstranit pozadí nepoužívá automatizovaná rozhodnutí, i když může generovat základní uživatelské profily, 
				právním základem je náš oprávněný zájem pro komerční účely a poskytování personalizovaných nabídek.<br>
				Odstranit pozadí může také použít informace o uživateli ve formě agregovaných a anonymních dat k jejich zobrazení třetím stranám. 
				Můžete také sdílet statistiky a demografické informace o uživatelích a jejich používání služby s třetími stranami. 
				Nic z toho však těmto třetím stranám neumožní vás osobně identifikovat.</p>

			<h5>5.1. V e-mailech a kontaktních formulářích</h5>
			<p>Webové stránky mají šifrování SSL, které uživateli umožňuje bezpečně odesílat osobní údaje prostřednictvím standardních kontaktních formulářů.<br>
				Shromážděné osobní údaje budou předmětem automatizovaného zpracování a budou začleněny do příslušných souborů 
				záznamu o činnostech zpracování a jehož vlastníkem je Remove Background.</p>
			<p>V tomto smyslu:</p>
			<ul>
				<li>Obdržíme vaši IP adresu, která bude použita k ověření původu zprávy, abychom vám mohli nabídnout adekvátní nabídku 
					doporučení (například prezentovat informace ve správném jazyce) a odhalit případné nesrovnalosti 
					(například možné pokusy o kybernetický útok na Službu) a také údaje související s vaším ISP.</li>
				<li>Stejně tak nám můžete poskytnout svá data telefonicky, e-mailem a dalšími uvedenými komunikačními prostředky.</li>
			</ul>
			<p>Pokud jde o použitý platební prostředek:</p>
			<ul>
				<li>Naši poskytovatelé platebních služeb, kteří platí za poskytování našich služeb, jsou kreditní nebo debetní karty. 
					Služba ani její zaměstnanci nebudou mít nikdy přístup k bankovním údajům (například k číslu kreditní karty) 
					které uživatel jako zákazník poskytne těmto třetím stranám.</li>
			</ul>


			<h3>6. Uchovávání dat</h3>
			<p>Níže je uvedeno, jak dlouho jsou údaje zpracovávané Službou uchovávány:</p>
			<ul>
				<li>Rozčleněná data budou uchovávána bez období smazání.</li>
				<li>
					Zákaznická data budou uchovávána po nezbytné minimum a mohou být uchovávána do:
					<ul>
						<li>5 let, podle čl. 1964 občanského zákoníku (osobní jednání bez zvláštní lhůty).</li>
						<li>6 let, podle čl. 30 obchodního zákoníku (např. účetní knihy nebo faktury).</li>
					</ul>
				</li>
				<li>Údaje uživatelů budou uchovávány po dobu maximálně 12 měsíců, aby bylo možné vyřídit jejich požadavky.</li>
			</ul>


			<h3>7. Data sdílená s třetími stranami</h3>
			<p>Existují třetí strany, které spravují část služby.<br>
				Odebrat pozadí od nich vyžaduje, aby kromě svých vlastních zásad dodržovali tyto zásady ochrany osobních údajů. Odebrat pozadí však nenese odpovědnost za dodržování uvedených zásad.<br>
				Za určitých okolností může Remove Background sdílet, používat nebo uchovávat s třetími stranami jakékoli shromážděné osobní údaje:</p>
			<ul>
				<li>Poskytování služby:</li>
			</ul>
			<p>Poskytovatelé služeb, kteří provádějí funkce naším jménem, jako jsou platební služby, webhosting, obchodní analýzy, zákaznický servis nebo webový marketing. Tito poskytovatelé služeb mohou shromažďovat informace, které jsou nezbytné k výkonu jejich funkcí, a mít k nim přístup, ale nesmějí tyto informace sdílet ani používat k jiným účelům.</p>
			<ul>
				<li>Spolupráce s příslušnými orgány:</li>
			</ul>
			<p>Pokud se domníváme, že je to přiměřeně nutné k uspokojení jakéhokoli zákona, právního procesu nebo oprávněného zájmu. V každém případě poskytneme pouze nezbytně požadované informace.</p>


			<h3>8. Bezpečnostní opatření</h3>
			<p>Odstranit pozadí přijímá všechna nezbytná technická a organizační opatření
				chránit bezpečnost a integritu shromážděných osobních a neosobních informací. 
				A to jak proti neoprávněnému přístupu, tak proti jeho náhodné změně, ztrátě nebo zničení.<br>
				V žádném případě nemůže Remove Background zaručit absolutní bezpečnost shromážděných informací, 
				takže musíte vždy spolupracovat a používat zdravý rozum ohledně sdílených informací.<br>
				Berete na vědomí a berete na vědomí, že i po odstranění mohou být osobní a neosobní údaje 
				zůstanou viditelné v mezipaměti nebo pokud je ostatní uživatelé zkopírovali nebo uložili.</p>


			<h3>9. Změny zásad ochrany osobních údajů</h3>
			<p>Tyto zásady ochrany osobních údajů můžeme v budoucnu aktualizovat. O jeho změnách vás budeme informovat zasláním oznámení na uvedenou e-mailovou adresu a/nebo umístěním oznámení na nápadné místo na našich webových stránkách.</p>


			<h3>10. Kontakt</h3>
			<p>Pokud máte dotazy k těmto Zásadám ochrany osobních údajů, kontaktujte nás na adrese:</p>
			<p>E-mail: {supportLink}<br> 
				Adresa: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španělsko.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Poslední aktualizace: 10. června 2024',
		content: `
			<h3>1. Kdo je zodpovědný a jak je kontaktovat?</h3>
			<p>Správcem tohoto webu je Remove Background S.L s adresou Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španělsko.</p>
			<p>Můžete ho kontaktovat prostřednictvím e-mailu na adrese {supportLink}.</p>

			<h3>2. Jaká data se shromažďují?</h3>
			<p>
				Automaticky shromažďujeme údaje prostřednictvím souborů cookie, které načteme do vašeho zařízení, včetně analýz. 
				Shromažďujeme také IP, ze které je připojení provedeno, typ použitého zařízení a jeho vlastnosti, 
				verzi operačního systému, typ prohlížeče, jazyk, datum, zemi, čas požadavku, 
				adresa URL, ze které přicházíte, adresa URL, na kterou přecházíte, nebo používaná mobilní síť.<br>
				Uživatel nám dobrovolně poskytne některé informace, jako je jeho jméno a příjmení, e-mail nebo bankovní údaje 
				abyste nás mohli kontaktovat, přihlásit se ke službě nebo zakoupit předplatné.
			</p>

			<h3>3. K čemu se shromážděná data používají?</h3>
			<p>
				Služba použije shromážděné údaje mimo jiné ke správě a aktualizaci služby, odpovídá na vaše požadavky, 
				zasílat vám náš newsletter a propagační nabídky e-mailem, spravovat vaši registraci na platformě, spravovat a poskytovat 
				služby související s vaším předplatným, zpracovávat vámi provedené platby a vystavovat příslušné faktury, 
				udržovat bezpečnost služby, vyšetřovat nezákonné aktivity, prosazovat naše smluvní podmínky a 
				pomáhat bezpečnostním složkám a orgánům státu v rámci jejich případných vyšetřování.
			</p>

			<h3>4. Jak dlouho jsou uchovávány?</h3>
			<ul>
				<li>Rozčleněná data budou uchovávána bez období smazání.</li>
				<li>
					Zákaznická data budou uchovávána po nezbytné minimum a mohou být uchovávána do:
					<ul>
						<li>5 let, podle čl. 1964 občanského zákoníku (osobní jednání bez zvláštní lhůty).</li>
						<li>6 let, podle čl. 30 obchodního zákoníku (např. účetní knihy nebo faktura).</li>
					</ul>
				</li>
				<li>Údaje uživatelů budou uchovávány po dobu maximálně 12 měsíců, aby bylo možné vyřídit jejich požadavky.</li>
				<li>Uživatelské údaje nahrané Službou na stránky a profily na sociálních sítích budou uchovávány od okamžiku, kdy uživatel dá svůj souhlas, až do jeho odvolání.</li>
			</ul>

			<h3>5. Jaká máte jako uživatel práva?</h3>

			<p>
				Právo na přístup: Dotčená strana má právo získat potvrzení od správce údajů, zda 
				nebo nejsou osobní údaje, které se jí týkají, zpracovávány.
			</p>
			<p>
				Právo na opravu: Dotčená strana má právo získat bez zbytečného odkladu od správce údajů 
				opravu osobních údajů, které jsou nepřesné a které se ho přímo dotýkají. Stejně tak bude zájemce 
				má právo na doplnění neúplných osobních údajů, a to i prostřednictvím dodatečného prohlášení.
			</p>
			<p>
				Právo na výmaz: Dotčená strana má právo na to, aby správce bez zbytečného odkladu vymazal údaje. 
				osobních údajů, které se ho týkají.
			</p>
			<p>
				Právo na omezení zpracování údajů: spočívá v získání omezení zpracování vašich údajů odpovědnou osobou, 
				ačkoli její výkon má dva aspekty: 1) Když zpochybníte přesnost svých osobních údajů, a to po dobu, která to umožňuje 
				pověřená osoba k ověření a 2) když vznesete námitku proti zpracování vašich osobních údajů, že odpovědná osoba 
				provádí na základě oprávněného zájmu nebo poslání veřejného zájmu, přičemž odpovědná osoba ověří, zda tyto důvody 
				zvítězit nad tvými.
			</p>
			<p>
				Právo na přenositelnost údajů: Dotčená strana má právo získat osobní údaje, které se jí týkají, 
				které poskytl správci údajů ve strukturovaném formátu pro běžné použití a mechanické čtení, a 
				předávat je jinému správci, aniž by tomu správce, kterému byly poskytnuty, bránil.
			</p>
			<p>
				V tomto smyslu bude mít zájemce právo na předání osobních údajů přímo od správce 
				kontrolovat, je-li to technicky možné.
			</p>

			<h3>6. Jak můžete uplatnit svá práva?</h3>

			<p>
				Svá práva na osobní údaje můžete uplatnit kdykoli zasláním e-mailu na: {supportLink} nebo poštovní adresu: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španělsko. V obou případech se musíte identifikovat svým jménem a příjmením, 
				a v případě potřeby také kopii vašeho DNI nebo národního průkazu totožnosti.<br>
				Kromě toho, pokud se domníváte, že existuje problém se způsobem, jakým Remove Background nakládá s vašimi daty, můžete své nároky nasměrovat 
				příslušnému <a href="{knowYourRightsLink}">úřadu pro ochranu údajů</a>, kterým je <a href="{aepdLink}">španělská agentura pro ochranu údajů</a> 
				ten, který je uveden v případě Španělska.
			</p>

			<h3>7. Jsou přijata bezpečnostní opatření?</h3>
			<p>
				Služba přijímá veškerá nezbytná technická a organizační opatření k ochraně bezpečnosti a integrity osob 
				a shromážděné neosobní údaje. A to jak proti neoprávněnému přístupu, tak proti náhodné změně, ztrátě nebo zničení.<br>
				Služba v žádném případě nemůže zaručit absolutní bezpečnost shromážděných informací, takže musíte spolupracovat a 
				pokud jde o sdílené informace, vždy používejte zdravý rozum.<br>
				Berete na vědomí a berete na vědomí, že i po smazání mohou osobní a neosobní informace zůstat viditelné v mezipaměti nebo 
				pokud jsou zkopírovány nebo uloženy jinými uživateli.
			</p>

			<h3>8. Existují přenosy osobních údajů nebo mezinárodní přenosy?</h3>

			<p>
				Nepřenášíme data ani mezinárodní převody. Existují však třetí strany, které spravují část Služby 
				že vyžadujeme dodržování našich zásad ochrany osobních údajů, pokud se na ně vztahují, a že mají své vlastní. 
				Tyto třetí strany jsou poskytovatelé služeb, kteří provádějí funkce naším jménem, jako je webhosting, 
				analytické monitorování nebo vývoj webu.<br>
				Také pokud se domníváme, že je to přiměřeně nutné k uspokojení jakéhokoli zákona, právního procesu nebo oprávněného zájmu. 
				V každém případě poskytneme pouze nezbytně požadované informace.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Poslední aktualizace: 21. června 2024',
		content: `
			<h3>Shrnutí</h3>
			<ul>
			    <li>Používané soubory cookie: <strong>Vlastní a třetí strany</strong></li>
			    <li>Používají se k získávání statistik? <strong>Ano, na základě našeho oprávněného zájmu o lepší správu služby.</strong></li>
			    <li>Služby třetích stran, které instalují soubory cookie prostřednictvím tohoto webu: <strong>Google, Google Analytics, Cloudflare a Stripe.</strong></li>
			</ul>

			<h3>Jak nakonfigurovat a zakázat soubory cookie</h3>
			<p>
			    Soubory cookie nainstalované ve vašem zařízení můžete povolit, blokovat nebo smazat z webového prohlížeče. Pokud nepovolíte instalaci souborů cookie na vašem zařízení, 
			    zážitek z prohlížení se může zhoršit. Níže naleznete, jak nakonfigurovat soubory cookie v každém prohlížeči:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Typy a použití</h3>
			<p>Služba používá vlastní soubory cookie a soubory cookie třetích stran ke zlepšení prohlížení, poskytování služby a získávání statistik o používání webu.</p>

			<h3>2. Co je to cookie a k čemu se používá?</h3>
			<p>
			    Cookie je textový soubor, který se odešle do webového prohlížeče vašeho počítače, mobilu nebo tabletu a používá se k ukládání a získávání informací o
			    procházení hotovo. Například, abyste si zapamatovali své uživatelské jméno a heslo nebo předvolby vašeho profilu.
			</p>

			<h3>3. Jaké typy souborů cookie existují?</h3>
			<p>Podle toho, kdo je spravuje:</p>
			<ul>
			    <li>vlastní soubory cookie; jsou odesílány do vašeho prohlížeče z našeho vlastního zařízení nebo webových domén.</li>
			    <li>Soubory cookie třetích stran; jsou odesílány do vašeho prohlížeče ze zařízení nebo webových domén, které nespravujeme přímo my, ale třetí subjekt, jako je Google.</li>
			</ul>
			<p>Podle toho, jak dlouho zůstávají aktivní, existují:</p>
			<ul>
			    <li>Soubory cookie relací; zůstanou v souboru cookie vašeho prohlížeče, dokud neopustíte webovou stránku, takže žádné nezůstanou ve vašem zařízení.</li>
			    <li>Trvalé soubory cookie; zůstanou ve vašem zařízení a naše webové stránky je přečtou pokaždé, když provedete novou návštěvu. Tyto soubory cookie přestanou fungovat po určitém datu.</li>
			</ul>
			<p>Konečně, podle jejich účelu, máme:</p>
			<ul>
			    <li>Technické soubory cookie; zlepšují prohlížení a správné fungování webu.</li>
			    <li>Personalizační soubory cookie; umožňují přístup ke službě s předdefinovanými charakteristikami na základě řady kritérií.</li>
			    <li>soubory cookie služby Analytics; umožňují měřit a statisticky analyzovat využívání poskytované služby.</li>
			</ul>
			<p>Seznam souborů cookie třetích stran, které používá <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Jejich soubory cookie (NID nebo CONSENT) umožňují personalizaci zobrazování reklam mimo Google nebo ukládání informací
			        jako je preferovaný jazyk při zobrazování výsledků vyhledávání.<br><a href="{externalLink: googleCookieTypes}">Další informace</a> o typech souborů cookie, které Google používá ve svých různých službách.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Jejich soubory cookie (například _ga) umožňují počítat, kolikrát uživatel navštíví webovou stránku, jak, kdy a odkud.<br>
			        V každém případě můžete soubory cookie Google Analytics zakázat <a href="{externalLink: disableGoogleAnalytics}">zde</a>.
			    </li>
			    <li>Cloudflare: Chcete-li se dozvědět o zásadách a používání souborů cookie Cloudflare, klikněte na <a href="{externalLink: cloudflareCookiesPolicy}">tento odkaz</a>.</li>
			    <li>Stripe: <a href="{externalLink: stripeCookiesPolicy}">zde</a> vyhledejte informace o zásadách a použití souborů cookie Stripe.</li>
			</ul>
		`
	}
};
